"use strict";

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

var _compliance = require("./compliance.helpers");

var _deriveRoute = require("./deriveRoute");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module("fleetviewApp").service("ComplianceRoutingProfileService", ComplianceRoutingProfileService); /* global _ */


ComplianceRoutingProfileService.$inject = ["$translate", "UserProvider", "PCMRegion", "FleetViewAPI"];

//Contains helper functions and data for calculating derived routes from routing profile data
function ComplianceRoutingProfileService($translate, UserProvider, PCMRegion, FleetViewAPI) {

  function getRoutingProfileByPrescribedRouteId(prescribedRouteId) {
    var url = FleetViewAPI.config.apiUrl + "v1/routing-profile/" + prescribedRouteId;
    return FleetViewAPI.$http.get(url);
  }

  function getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles) {

    var region = PCMRegion[UserProvider.getUser().region];

    //If no routing profile is specified, use the most lenient/most default settings
    if (!routingProfile) {
      return (0, _compliance.buildDefaultRoutingProfile)(latLonArray, offRouteMiles, region);
    }

    //Comes in format of string, "FiftyThreeFoot, NationalNetwork". Must parse and convert to bitflag
    if (routingProfile.classOverrides && typeof routingProfile.classOverrides === "string") {
      var classes = routingProfile.classOverrides.split(",");
      var bitFlag = 0;
      // TODO: replace for-of with iterator
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(classes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cls = _step.value;

          var clsNum = _compliance.routingProfileProps.classOverrides[cls.trim()];
          bitFlag += clsNum;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      routingProfile.classOverrides = bitFlag;
    }

    var isMetric = _compliance.routingProfileProps.unitTypes[routingProfile.unitsOfMeasure] === 1;
    var weight = routingProfile.totalWeight;
    if (isMetric) {
      //Weight for metric routing profiles is in metric tons. But web service expects kilograms. 1 metric ton = 1000 kg
      weight *= 1000;
    }
    var request = (0, _deriveRoute.buildDerivedRouteRequest)({ region: region, routingProfile: routingProfile, latLonArray: latLonArray, offRouteMiles: offRouteMiles, weight: weight, isMetric: isMetric });

    //If vehicle type is set to auto, don't pass in TruckCfg
    if (_compliance.routingProfileProps.vehicleTypes[routingProfile.vehicleType] === 2 && request.RoutingOptions) {
      delete request.RoutingOptions["TruckCfg"];
    }

    return request;
  }

  var service = { getDerivedRouteRequest: getDerivedRouteRequest, getRoutingProfileByPrescribedRouteId: getRoutingProfileByPrescribedRouteId };
  return service;
}


// WEBPACK FOOTER //
// ./app/compliance/complianceRoutingProfile.service.js